import { r as registerInstance, h, H as Host } from './index-1755b6c5.js';

const dynamicInputCss = ".service-calls-dynamic-input{display:block;position:relative}.service-calls-dynamic-input__dynamic-container.is-min-reached ux-icon{opacity:0.3;cursor:default}.service-calls-dynamic-input__input-container{display:flex;align-items:center;margin:0 0 10px}.service-calls-dynamic-input__input-container ux-icon{margin:0 0 0 20px;opacity:1;cursor:pointer;transition:opacity 0.2s ease-in-out}.service-calls-dynamic-input .ux-text-link{display:inline-block;cursor:pointer;transition:color 0.2s ease-in-out}.service-calls-dynamic-input .ux-text-link.is-max-reached{color:#a6a6a6;cursor:default}";
const ServiceCallsDynamicInputStyle0 = dynamicInputCss;

const DynamicInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.baseClass = "service-calls-dynamic-input";
        this.addInput = () => {
            if (this.disabled)
                return;
            if (this.counter < this.maxItems) {
                this.counter++;
                this.items.push(this.listItemElement());
                this.minReached = false;
                this.checkMinMaxReached();
            }
        };
        this.removeInput = (event) => {
            var _a, _b;
            if (this.disabled)
                return;
            if (this.counter > this.minItems) {
                this.counter--;
                const target = event.target.closest("ux-icon");
                if (!(target === null || target === void 0 ? void 0 : target.parentElement))
                    return;
                const children = ((_a = target.parentElement.parentElement) === null || _a === void 0 ? void 0 : _a.children) || [];
                const index = [...Array.from(children)].indexOf(target.parentElement);
                (_b = target.parentElement.parentElement) === null || _b === void 0 ? void 0 : _b.removeChild(target.parentElement);
                this.items.splice(index, 1);
                this.checkMinMaxReached();
            }
        };
        this.checkMinMaxReached = () => {
            this.minReached = this.counter === this.minItems;
            this.maxReached = this.counter === this.maxItems;
        };
        this.listItemElement = (value = "") => {
            return (h("div", { class: `${this.baseClass}__input-container` }, h("input", { class: "ux-input", type: "text", value: value, name: this.inputName, disabled: this.disabled }), h("ux-icon", { name: "delete", onClick: (e) => this.removeInput(e) })));
        };
        this.addText = "+ add another error number";
        this.inputName = "errorNumber";
        this.initItems = 1;
        this.minItems = 1;
        this.maxItems = 6;
        this.prefilledValues = [];
        this.disabled = false;
        this.counter = 0;
        this.items = [];
        this.minReached = false;
        this.maxReached = false;
    }
    componentWillLoad() {
        this.setInitItems();
    }
    setInitItems() {
        let count = 0;
        const items = [];
        for (let i = 0; i < this.initItems; i++) {
            count++;
            items.push(this.listItemElement(this.prefilledValues[i]));
        }
        this.counter = count;
        this.items = items;
        this.checkMinMaxReached();
    }
    render() {
        return (h(Host, { key: '4ee565017491a534e68b8fb54453240c968a5e88', class: `${this.baseClass}` }, h("div", { key: '57383626f70b6180118bf4d632410b2720b68094', class: `${this.baseClass}__dynamic-container ${this.minReached || this.disabled ? "is-min-reached" : ""}` }, this.items.map((item) => {
            return item;
        })), h("slot", { key: 'dc97bde6ee090461d3cafc9406e3e7109f578316', name: "info" }), h("div", { key: '8bc2d56def363bf02e337739b927ab0e1e53a68a', class: `ux-text-link ux-text-link--primary ${this.maxReached || this.disabled ? "is-max-reached" : ""}`, onClick: this.addInput }, this.addText)));
    }
    static get watchers() { return {
        "prefilledValues": ["setInitItems"]
    }; }
};
DynamicInput.style = ServiceCallsDynamicInputStyle0;

export { DynamicInput as service_calls_dynamic_input };

//# sourceMappingURL=service-calls-dynamic-input.entry.js.map